import {BeneficiariesApi, BeneficiaryPersonDto} from 'Beneficiaries/api';
import {BeneficiariesFilter} from 'Beneficiaries/ducks/beneficiaries';
import {BeneficiaryPersonPercentage} from 'Beneficiaries/models/BeneficiaryPersonPercentage';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';

const beneficiariesApi = new BeneficiariesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  fetchBeneficiaries: (filter?: BeneficiariesFilter) =>
    withCancellation(cancelToken =>
      beneficiariesApi
        .searchBeneficiaries('1', {
          params: {...filter},
          ...getAxiosConfig(cancelToken),
        })
        .then(handleResponse)
    ),
  getBeneficiaryDetails: async (policyNumber: string) => {
    const response = await beneficiariesApi.beneficiaryDetails(policyNumber, '1', getAxiosConfig());

    return handleResponse(response);
  },
  updateBeneficiaryPerson: async (beneficiaryPerson: BeneficiaryPersonDto, policyNumber: string) => {
    const response = await beneficiariesApi.updateBeneficiaryPerson(
      policyNumber,
      '1',
      beneficiaryPerson,
      getAxiosConfig()
    );

    return handleResponse(response);
  },
  updateBeneficiaryPercentages: async (
    policyNumber: string,
    beneficiaryPersonPercentages: BeneficiaryPersonPercentage[]
  ) => {
    const response = await beneficiariesApi.updateBeneficiaryPercentages(
      policyNumber,
      '1',
      beneficiaryPersonPercentages,
      getAxiosConfig()
    );

    return handleResponse(response);
  },
  addBeneficiaryPerson: async (beneficiaryPerson: BeneficiaryPersonDto, policyNumber: string) => {
    const response = await beneficiariesApi.addBeneficiaryPerson(
      policyNumber,
      '1',
      beneficiaryPerson,
      getAxiosConfig()
    );

    return handleResponse(response);
  },
  deleteBeneficiaryPerson: async (id: string, policyNumber: string) => {
    const response = await beneficiariesApi.deleteBeneficiaryPerson(policyNumber, id, '1', getAxiosConfig());

    return handleResponse(response);
  },
  updateBeneficiaryPolicy: async (beneficiaryPersons: BeneficiaryPersonDto[], policyNumber: string) => {
    const response = await beneficiariesApi.updateBeneficiaryPolicy(
      policyNumber,
      '1',
      beneficiaryPersons,
      getAxiosConfig()
    );

    return handleResponse(response);
  },
};
